module.exports = __webpack_public_path__ + "img/technology_bg_low.7d3aac5d.jpg";